/*
 * cart-drawer.js — slide-in cart replacing the /cart full-page redirect.
 * Uses Shopify ajax cart endpoints. Falls back gracefully to /cart for
 * no-JS users.
 * P2-026.
 */
(function () {
  "use strict";

  function money(cents) {
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function escapeHTML(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function render(cart) {
    var body = document.querySelector("[data-cart-drawer-body]");
    var foot = document.querySelector("[data-cart-drawer-foot]");
    if (!body || !foot) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cd-empty">' +
          '<strong>Your cart is empty.</strong>' +
          '<span>Need help choosing texture, length, or samples? We can guide you.</span>' +
        '</div>';
      foot.innerHTML =
        '<a class="cd-checkout" href="/collections/all">Shop hair</a>' +
        '<a class="cd-secondary" href="/pages/contact-us">Ask for guidance</a>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = (item.featured_image && item.featured_image.url) || item.image || "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      return '<div class="cd-item">' +
        '<img src="' + escapeHTML(img) + '" alt="" loading="lazy">' +
        '<div>' +
          '<div class="cd-item__title">' + escapeHTML(item.product_title) + '</div>' +
          (variant ? '<div class="cd-item__variant">' + escapeHTML(variant) + '</div>' : '') +
          '<div class="cd-qty">' +
            '<button type="button" data-cd-qty="-1" data-cd-key="' + escapeHTML(item.key) + '"' + (item.quantity <= 1 ? ' disabled aria-disabled="true"' : '') + '>&minus;</button>' +
            '<span>' + escapeHTML(item.quantity) + '</span>' +
            '<button type="button" data-cd-qty="+1" data-cd-key="' + escapeHTML(item.key) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-line-total">' + money(item.final_line_price) + '</div>' +
      '</div>';
    }).join("");

    foot.innerHTML =
      '<div class="cd-totals"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<a class="cd-checkout" href="/checkout" data-prarvi-event="checkout_start" data-prarvi-placement="cart_drawer" data-prarvi-audience="retail">Secure checkout &rarr;</a>' +
      '<a class="cd-secondary" href="/collections/all">Continue shopping</a>' +
      '<div class="cd-trust" role="group" aria-label="Cart support notes">' +
        '<span>Secure checkout</span>' +
        '<span>14-day returns on unworn items</span>' +
        '<span>Need help? <a href="/pages/contact-us">Contact Prarvi</a></span>' +
      '</div>';
  }

  function refresh() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    var d = document.querySelector("[data-cart-drawer]");
    if (!d) return;
    d.removeAttribute("hidden");
    setTimeout(function () { d.setAttribute("data-open", "true"); }, 10);
    document.body.style.overflow = "hidden";
    refresh();
  }

  function close() {
    var d = document.querySelector("[data-cart-drawer]");
    if (!d) return;
    d.removeAttribute("data-open");
    setTimeout(function () { d.setAttribute("hidden", ""); }, 250);
    document.body.style.overflow = "";
  }

  function changeQty(key, delta) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.find(function (i) { return i.key === key; });
      if (!line) return;
      if (delta < 0 && line.quantity <= 1) return;
      var qty = Math.max(1, line.quantity + delta);
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    }).then(function () { refresh(); });
  }

  function init() {
    var d = document.querySelector("[data-cart-drawer]");
    if (!d) return;

    // Expose refresh globally so main-cart.liquid can trigger it
    window.Prarvi = window.Prarvi || {};
    window.Prarvi.refreshCartDrawer = refresh;
    window.Prarvi.openCartDrawer = open;
    window.Prarvi.closeCartDrawer = close;

    // Listen for custom update event
    document.addEventListener('prarvi:cart:updated', refresh);
    document.addEventListener('prarvi:cart:open', open);

    d.querySelectorAll("[data-cart-drawer-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });

    d.addEventListener("click", function (e) {
      var qtyBtn = e.target.closest("[data-cd-qty]");
      if (qtyBtn) {
        var delta = parseInt(qtyBtn.getAttribute("data-cd-qty"), 10);
        var key = qtyBtn.getAttribute("data-cd-key");
        changeQty(key, delta);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && d.hasAttribute("data-open")) close();
    });

    // Intercept Add to Cart forms — POST via ajax, then open drawer
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var action = (form.getAttribute("action") || "").split("?")[0];
      if (action !== "/cart/add") return;
      // Skip if the form opts out
      if (form.getAttribute("data-no-drawer") === "true") return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status && data.status >= 400) {
            // Show error inline via existing modal if available
            if (window.timber && window.timber.showAjaxError) window.timber.showAjaxError({ responseText: JSON.stringify(data) }, "");
            if (window.Prarvi && typeof window.Prarvi.track === "function") {
              window.Prarvi.track("add_to_cart_error", {
                variant_id: fd.get("id") || "",
                quantity: fd.get("quantity") || "1",
                audience: "retail",
                placement: "cart_drawer_form_intercept",
                error_status: data.status || ""
              });
            }
            return;
          }
          if (window.Prarvi && typeof window.Prarvi.track === "function") {
            var title = data && (data.product_title || data.title) ? (data.product_title || data.title) : "";
            window.Prarvi.track("add_to_cart_success", {
              product_title: title,
              variant_id: data && (data.variant_id || data.id) ? (data.variant_id || data.id) : fd.get("id") || "",
              product_id: data && data.product_id ? data.product_id : "",
              quantity: data && data.quantity ? data.quantity : fd.get("quantity") || "1",
              value: data && data.final_price ? data.final_price / 100 : "",
              currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "",
              product_funnel: title.toLowerCase().indexOf("sample") > -1 ? "sample" : "full_size",
              sample: title.toLowerCase().indexOf("sample") > -1,
              audience: "retail",
              placement: "cart_drawer_form_intercept"
            });
          }
          open();
        })
        .catch(function () { form.submit(); });
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
